import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const incentiveDocumentStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const incentiveDocumentObject = z.object({
  id: z.string().uuid(),
  collectionIncentiveId: z.string().uuid(),
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  status: incentiveDocumentStatus,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const incentiveDocumentCreateInputObject = incentiveDocumentObject
  .pick({
    id: true,
    collectionIncentiveId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .extend({
    id: incentiveDocumentObject.shape.id.nullish(),
    status: incentiveDocumentObject.shape.status.nullish(),
  })

export const incentiveDocumentUpdateInputObject = incentiveDocumentObject
  .pick({
    id: true,
    collectionIncentiveId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .partial()
  .required({ id: true })

export type IncentiveDocumentType = z.infer<typeof incentiveDocumentObject>

export const propertyMap = {
  id: sql`incentive_document.id`,
  collectionIncentiveId: sql`incentive_document.collection_incentive_id`,
  privateFileId: sql`incentive_document.private_file_id`,
  gcsIdentifier: sql`incentive_document.gcs_identifier`,
  url: sql`incentive_document.url`,
  fileName: sql`incentive_document.file_name`,
  mimeType: sql`incentive_document.mime_type`,
  status: sql`incentive_document.status`,
  clientId: sql`incentive_document.client_id`,
  insertUserId: sql`incentive_document.insert_user_id`,
  editUserId: sql`incentive_document.edit_user_id`,
  createdAt: sql`incentive_document.created_at`,
  updatedAt: sql`incentive_document.updated_at`,
  deletedAt: sql`incentive_document.deleted_at`,
}

export default incentiveDocumentObject
